var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCorrect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 25C0 11.1929 11.1929 0 25 0C38.8071 0 50 11.1929 50 25C50 38.8071 38.8071 50 25 50C11.1929 50 0 38.8071 0 25Z",
    fill: "#4DBD74"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.3447 33.3576C25.2724 33.6604 25.1171 33.937 24.8965 34.1561C24.5116 34.5444 23.9729 34.7386 23.4294 34.6851C22.5566 34.7462 21.7593 34.1893 21.5142 33.3474L15.7683 27.592C15.1245 26.8647 15.1571 25.7606 15.8428 25.0728C16.5284 24.385 17.6299 24.3514 18.356 24.9962L22.7978 29.4567L31.8852 13.3078C32.1489 12.8243 32.5962 12.4681 33.1256 12.32C33.6551 12.1719 34.2218 12.2446 34.697 12.5215C35.6805 13.1297 36.0051 14.4104 35.4306 15.4155L25.3447 33.3576Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorrect);
export default __webpack_public_path__ + "static/media/correct.8b16cec26d4e2fc5078885af938b49fd.svg";
export { ForwardRef as ReactComponent };